module.exports = __webpack_public_path__ + "img/2-2k.73601dac.png";